// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"b619ce40","72":"8e0581cb","309":"7a47d95a","351":"45df1ff8","397":"89c426d0","413":"e907c225","442":"65bb8b34","474":"6040bfda","500":"75a9103f","555":"e3c96b2f","631":"4387a0d1","647":"cda72e93","666":"7dc0ac8a","913":"5d8df7fc","960":"e2d87068"}[chunkId] + ".chunk.js";
};